import styled, { css } from 'styled-components';

import { IMilePriceBadge } from './';

type BadgeVariantType = Pick<IMilePriceBadge, 'variant' | 'isRounded'>;

export const BadgeWrapper = styled.span<BadgeVariantType>`
  padding: 5px 0px;
  font-size: 12px;
  font-weight: 700;
  transition: all 0.3s ease;
  color: ${({ theme }) => theme.palette.grey600};
  ${({ variant }) =>
    variant === 'solid' &&
    css`
      padding: 5px 10px;
      background-color: ${({ theme }) => theme.palette.darkGrey};
      color: ${({ theme }) => theme.palette.white};

      &:hover {
        background-color: ${({ theme }) => theme.palette.primaryBrand};
        color: ${({ theme }) => theme.palette.white};
      }
    `}
  ${({ variant }) =>
    variant === 'transparent' &&
    css`
      &:hover {
        color: ${({ theme }) => theme.palette.primaryBrand};
      }
    `}
    ${({ isRounded }) =>
    isRounded &&
    css`
      border-radius: 20px;
    `};
`;

export const MileAndPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

export const OrText = styled.span`
  font-size: 11px;
  margin-right: 4px;
`;
